import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es difícil de seguir?',
  a: 'No, está diseñado para mujeres ocupadas; no requiere horas de cocina.'
}, {
  q: '¿Debo comprar suplementos caros?',
  a: 'No, todo lo que necesitas está en tu supermercado local (Walmart, Aldi, etc.).'
}, {
  q: '¿Funciona si ya pasé la menopausia?',
  a: 'Sí, es precisamente cuando más efectivo es este protocolo.'
}, {
  q: '¿Tengo que dejar el café?',
  a: 'No, aprenderás a tomarlo de forma que ayude a tu metabolismo en lugar de estresarlo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-22">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white rounded-2xl overflow-hidden border border-brand-rose/20 shadow-sm" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-24">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-25">
                <span className="font-bold text-brand-green text-lg pr-4" data-id="element-26">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-rose transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-27" />
              </button>
              <AnimatePresence data-id="element-28">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-29">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-30">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}